<template>
  <div v-if="visited.length" class="route-tabs-bar">
    <button
      v-show="canScrollLeft"
      type="button"
      class="route-tabs-bar__nav"
      aria-label="向左滚动"
      @click="scrollTabs(-160)"
    >
      ‹
    </button>
    <div ref="scrollRef" class="route-tabs-bar__scroll" @scroll="updateScrollState">
      <div class="route-tabs-bar__list">
        <el-dropdown
          v-for="tab in visited"
          :key="tab.path"
          trigger="contextmenu"
          @command="function (cmd) { onMenuCommand(cmd, tab.path) }"
        >
          <button
            type="button"
            class="route-tab"
            :class="{ active: activePath === tab.path }"
            @click="goTab(tab.path)"
            @mouseup.middle.prevent="closeTab(tab.path)"
          >
            <span class="route-tab__label">{{ tab.title }}</span>
            <span
              v-if="!tab.affix"
              class="route-tab__close"
              title="关闭"
              @click.stop="closeTab(tab.path)"
            >
              <i class="el-icon-close"></i>
            </span>
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="refresh">刷新</el-dropdown-item>
            <el-dropdown-item command="close" :disabled="tab.affix">关闭</el-dropdown-item>
            <el-dropdown-item command="closeOthers">关闭其他</el-dropdown-item>
            <el-dropdown-item command="closeAll">关闭全部</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <button
      v-show="canScrollRight"
      type="button"
      class="route-tabs-bar__nav"
      aria-label="向右滚动"
      @click="scrollTabs(160)"
    >
      ›
    </button>
    <el-dropdown trigger="click" @command="function (cmd) { onMenuCommand(cmd, activePath) }">
      <button type="button" class="route-tabs-bar__more" aria-label="页签操作">
        <i class="el-icon-arrow-down"></i>
      </button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="refresh">刷新当前</el-dropdown-item>
        <el-dropdown-item command="close" :disabled="isActiveAffix">关闭当前</el-dropdown-item>
        <el-dropdown-item command="closeOthers">关闭其他</el-dropdown-item>
        <el-dropdown-item command="closeAll">关闭全部</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import {
  getVisitedTabs,
  removeTab,
  closeOtherTabs,
  closeAllTabs
} from '@/utils/tabsStore'

export default {
  name: 'RouteTabs',
  data() {
    return {
      visited: getVisitedTabs(),
      canScrollLeft: false,
      canScrollRight: false
    }
  },
  computed: {
    activePath() {
      return this.$route.path
    },
    isActiveAffix() {
      const tab = this.visited.find(function (t) { return t.path === this.activePath }.bind(this))
      return tab && tab.affix
    }
  },
  watch: {
    activePath() {
      this.syncVisited()
      this.$nextTick(function () {
        this.updateScrollState()
      })
    }
  },
  mounted() {
    this.syncVisited()
    this.$nextTick(function () {
      this.updateScrollState()
    })
    window.addEventListener('resize', this.updateScrollState)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScrollState)
  },
  methods: {
    syncVisited() {
      this.visited = getVisitedTabs()
    },
    updateScrollState() {
      var el = this.$refs.scrollRef
      if (!el) {
        this.canScrollLeft = false
        this.canScrollRight = false
        return
      }
      var max = el.scrollWidth - el.clientWidth
      this.canScrollLeft = el.scrollLeft > 2
      this.canScrollRight = max > 2 && el.scrollLeft < max - 2
    },
    scrollTabs(delta) {
      var el = this.$refs.scrollRef
      if (el) el.scrollBy({ left: delta, behavior: 'smooth' })
    },
    goTab(path) {
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
    },
    closeTab(path) {
      var currentIndex = this.visited.findIndex(function (t) { return t.path === path })
      if (currentIndex < 0) return
      var isActive = this.$route.path === path
      if (!removeTab(path)) return
      this.syncVisited()
      if (!isActive) return
      var fallback =
        this.visited[currentIndex] ||
        this.visited[currentIndex - 1] ||
        this.visited[0]
      this.$router.push((fallback && fallback.path) || '/')
    },
    onMenuCommand(command, path) {
      if (command === 'refresh') {
        if (path === this.$route.path) {
          this.$emit('refresh')
        } else {
          var self = this
          this.$router.push(path).then(function () {
            self.$emit('refresh')
          })
        }
        return
      }
      if (command === 'close') {
        this.closeTab(path)
        return
      }
      if (command === 'closeOthers') {
        closeOtherTabs(path)
        this.syncVisited()
        if (!this.visited.some(function (t) { return t.path === this.$route.path }.bind(this))) {
          this.$router.push(path)
        }
        return
      }
      if (command === 'closeAll') {
        closeAllTabs()
        this.syncVisited()
        if (!this.visited.some(function (t) { return t.path === this.$route.path }.bind(this))) {
          this.$router.push('/')
        }
      }
    }
  }
}
</script>

<style scoped>
.route-tabs-bar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 16px 0;
  min-height: 34px;
  background: #fff;
  border-bottom: none;
  flex-shrink: 0;
}

.route-tabs-bar__scroll {
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}

.route-tabs-bar__scroll::-webkit-scrollbar {
  display: none;
}

.route-tabs-bar__list {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
  min-width: min-content;
}

.route-tabs-bar__nav,
.route-tabs-bar__more {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
}

.route-tabs-bar__nav:hover,
.route-tabs-bar__more:hover {
  border-color: #bfdbfe;
  color: #2563eb;
  background: #f8fafc;
}

.route-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  height: 28px;
  padding: 0 10px;
  margin: 0;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  transition: color 0.15s, background 0.15s;
}

.route-tab:hover {
  color: #2563eb;
  background: #f8fafc;
}

.route-tab.active {
  color: #2563eb;
  font-weight: 600;
  background: #eff6ff;
  border-color: #dbeafe;
}

.route-tab__label {
  line-height: 1;
  white-space: nowrap;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.route-tab__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  color: #94a3b8;
  font-size: 12px;
}

.route-tab__close:hover {
  background: #e2e8f0;
  color: #334155;
}

.route-tab.active .route-tab__close:hover {
  background: #dbeafe;
  color: #1d4ed8;
}
</style>



// WEBPACK FOOTER //
// src/components/RouteTabs/index.vue